<template>
  <div
    class="search-wrapper"
  >
    <p class="search-wrapper__heading">
      Välj butik
    </p>
    <p class="search-wrapper__description">
      Visa vilka butiker du kan köpa matkassen från.
    </p>
    <search-input
      @search="emitSearch"
    />
  </div>
</template>

<script>
import searchInput from './searchInput'

export default {
  name: 'SearchWrapper',
  components: {
    'search-input': searchInput
  },
  methods: {
    emitSearch (val) {
       this.$emit('search', val)
    }
  }
}
</script>

<style lang="scss">
.search-wrapper {
  @include media-breakpoint-up(md) {
    padding: 0 4.5rem;
  }

  @include media-breakpoint-up(lg) {
    padding: 0 3rem;
  }

  @include media-breakpoint-up(xl) {
    padding: 0 4.5rem;
  }

  &__heading {
    @include font(text, 2, "black");

    text-transform: uppercase;
    margin-bottom: 0.5rem;
  }

  &__description {
    @include font(text, 3, "light");

    margin-bottom: 1rem;
    margin-top: 0;
  }
}
</style>
